module.exports = __webpack_public_path__ + "media/apps/gif-android-12-firstframe-4c0ce543.jpg";